import axiosInstance from './axiosConfig';

const customerService = {
  getAll: async (page = 1, limit = 10) => {
    console.log('API CALL → page:', page, 'limit:', limit);

    const response = await axiosInstance.get(
      `categories?page=${page}&limit=${limit}`
    );

    // Extract the actual data array - it's likely nested like categories
    const customers = response.data.data ?? response.data;
    
    // Debug: Check if IDs are present
    console.log('Customers from API:', customers);
    if (customers.length > 0) {
      console.log('First customer keys:', Object.keys(customers[0]));
    }
    
    return customers;
  },
  
  getAvailableRoutes: async () => {
    const response = await axiosInstance.get('/routes/active');
    return response.data.data ?? response.data;
  },
  
  getById: async (id) => {
    const response = await axiosInstance.get(`/categories/${id}`);
    return response.data.data ?? response.data;
  },
  
  create: async (payload) => {
    const response = await axiosInstance.post('/categories/add', payload);
    return response.data;
  },
  
  update: async (id, data) => {
    console.log('Updating customer with ID:', id);
    console.log('Update data:', data);
    
    const response = await axiosInstance.put(`/categories/edit/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/categories/delete/${id}`);
    return response.data;
  },
  
  filter: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    
    const response = await axiosInstance.get(
      params.toString()
        ? `/categories?${params.toString()}`
        : '/categories'
    );
    return response.data.data ?? response.data;
  },
};

export default customerService;